"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExecutionQueue = exports.EXECUTION_QUEUE_DESTROYED_ERROR_MESSAGE = void 0;
const GatherEventEmitter_1 = require("gather-common-including-video/dist/src/public/GatherEventEmitter");
const fpHelpers_1 = require("gather-common-including-video/dist/src/public/fpHelpers");
var ExecutionQueueEvent;
(function (ExecutionQueueEvent) {
    ExecutionQueueEvent["IsExecutingChange"] = "isExecutingChange";
})(ExecutionQueueEvent || (ExecutionQueueEvent = {}));
exports.EXECUTION_QUEUE_DESTROYED_ERROR_MESSAGE = "Destroyed execution queue";
class ExecutionQueue extends GatherEventEmitter_1.GatherEventEmitter {
    _q = [];
    isExecuting = false;
    _isDestroyed = false;
    addIsExecutingChangeListener = (0, fpHelpers_1.partial)([ExecutionQueueEvent.IsExecutingChange], this.addEventListener.bind(this));
    async run(f) {
        return new Promise((resolve, reject) => {
            const runF = async () => {
                if (this._isDestroyed) {
                    reject(new Error(exports.EXECUTION_QUEUE_DESTROYED_ERROR_MESSAGE));
                    return;
                }
                try {
                    const result = await f();
                    resolve(result);
                }
                catch (err) {
                    if (this._isDestroyed) {
                        console.log("Execution queue destroyed while executing");
                    }
                    reject(err);
                }
            };
            this._q.push(runF);
            this._execute();
        });
    }
    waitUntilFinishedExecuting() {
        if (!this.isExecuting)
            return Promise.resolve();
        return new Promise((resolve) => {
            const removeListener = this.addIsExecutingChangeListener((isExecuting) => {
                if (!isExecuting) {
                    removeListener();
                    resolve();
                }
            });
        });
    }
    async _execute() {
        if (this.isExecuting)
            return;
        this.isExecuting = true;
        this.publishEvent(ExecutionQueueEvent.IsExecutingChange, true);
        let nextFunction;
        while ((nextFunction = this._q.shift())) {
            await nextFunction();
        }
        this.isExecuting = false;
        this.publishEvent(ExecutionQueueEvent.IsExecutingChange, false);
    }
    async destroy() {
        this._isDestroyed = true;
    }
}
exports.ExecutionQueue = ExecutionQueue;
//# sourceMappingURL=ExecutionQueue.js.map